<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <DefaultTmpl :mode="$appUtils.isMobile() ? 'mobile_search' : 'default'">
    <template v-slot:main>
      <head-utils title="Pesquisar carteiras de corretores"/>
      <breadcrumb :items="[{label: 'Pesquisar carteiras de corretores', path: 'broker_customers_wallets'}]"/>

      <form @submit.prevent.stop="submit">
        <ibox>
          <template v-slot:title v-if="!$appUtils.isMobile()">
            <h5>Filtros de Pesquisa</h5>
          </template>

          <template v-slot:content>
            <div v-if="!$appUtils.isMobile() || filterMode" class="container-fluid-grid">
              <div class="form-row" v-if="!$appUtils.isMobile() || filterMode">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="brokerCustomerWalletsUserId">Corretor</label>
                    <select id="brokerCustomerWalletsUserId"
                            type="text"
                            class="form-control form-control-sm"
                            v-model="search_params.user_id">
                      <option selected :value="undefined">[SELECIONE]</option>
                      <option v-for="p in brokers"
                              :key="p.id"
                              :value="p.id">{{ p.name }} {{ p.last_name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:footer>
            <div class="row" v-if="filterMode || !$appUtils.isMobile()">
              <div class="col-sm-12 t-r">
                  <span class="btn-group btn-group-sm" role="group" aria-label="Comandos de Pesquisa">
                      <button type="button" @click="reset" class="btn btn-secondary btn-sm"><svg-icon
                          icon="sync"/> Limpar</button>
                      <router-link to="/broker_customers_wallets/new" class="btn btn-dark btn-sm"><svg-icon
                          icon="plus"/> Criar Novo</router-link>
                      <button type="submit" class="btn btn-theme-1 btn-sm"><svg-icon icon="search"/> Pesquisar</button>
                  </span>
              </div>
            </div>

            <div class="row" v-if="$appUtils.isDesktop()">
              <div class="col-sm-12">
                <br/>

                <Pagination
                    :page_size="search.per_page"
                    :current_page="search.current_page"
                    :total_entries="search.total_entries"/>

                <Loading :visible="searching"/>

                <table class="table table-hover table-striped table-sm table-bordered">
                  <thead class="thead-dark thead-center">
                  <tr>
                    <th v-if="$appUtils.isEmpty(search_params.user_id)">CORRETOR</th>
                    <th>GRUPO CLIENTE</th>
                    <th>PRODUTOS</th>
                    <th class="column-1"/>
                  </tr>
                  </thead>
                  <tbody v-if="search && search.entries">
                  <tr v-for="(p, idx) in search.entries" :key="idx">
                    <td v-if="$appUtils.isEmpty(search_params.user_id)" class="v-m c-p" @click="edit(p.broker_id)">{{ p.broker_name }}</td>
                    <td class="v-m c-p" @click="edit(p.broker_id)">{{ p.customer_group_name }}</td>
                    <td class="v-m" @click="edit(p.broker_id)">
                      <div class="products-container" ref="productsContainer" @wheel="handelWheel($event, idx)">
                        <span v-for="(prd, index) in p.products" :key="index">
                          <span @click="destroyProduct($event, p.broker_id, p.customer_group_id, prd.id)">&times;</span>
                          {{prd.name}}
                        </span>
                      </div>
                    </td>
                    <td class="t-c v-m">
                      <button type="button" class="btn btn-danger btn-xs"
                              @click="destroyCustomerGroup($event, p.broker_id, p.customer_group_id)">
                        <svg-icon icon="trash-alt"/>
                      </button>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <Pagination
                    :page_size="search.per_page"
                    :current_page="search.current_page"
                    :total_entries="search.total_entries"/>
              </div>
            </div>

          </template>
        </ibox>
      </form>
    </template>

  </DefaultTmpl>
</template>
<script>
import DefaultTmpl from "@/templates/DefaultTmpl.vue";
import Loading from "@/components/particles/Loading.vue";
import Fab from "@/components/particles/Fab.vue";
import Pagination from "@/components/Pagination.vue";
import CRUDSearch from "@/mixins/CRUDSearch";
import {createNamespacedHelpers, mapMutations as mapMutModal, mapMutations} from "vuex";

const {mapGetters, mapActions} = createNamespacedHelpers('broker_customers_wallets');

export default {
  name: "BrokerCustomersWalletsSearch",
  components: {
    DefaultTmpl,
    Loading,
    Fab,
    Pagination
  },
  mixins: [
    CRUDSearch.mount('broker_customers_wallets')
  ],
  data() {
    return {
      isOpenFabMenu: false
    }
  },
  methods: {
    ...mapActions(['loadBrokers']),
    ...mapMutModal(['addModal', 'destroyModal']),
    getIntersectItemListener() {
      return this.$refs.end_grid;
    },
    edit(broker_id) {
      this.$router.push(`/broker_customers_wallets/new?broker_id=${broker_id}`);
    },
    handelWheel(e, idx) {
      e.preventDefault()
      if (e.deltaY !== 0) {
        this.$refs.productsContainer[idx].scrollLeft += e.deltaY; // Scroll horizontal
      }
    },
    destroyCustomerGroup(e, broker_id, customer_group_id) {
      e.stopPropagation();
      e.preventDefault();

      this.addModal({
        title: 'Excluir Grupo de Clientes',
        size: 'small',
        body: 'Deseja realmente excluir este crupo de cliente? Todos as associações com produtos também serão excluídos.',
        buttons: [{
          type: 'ok',
          class: 'btn btn-danger btn-sm',
          method: id => {
            this.destroyModal(id);
            this.$appHttp.delete(`/v1/broker_customers_wallets/destroy_customer_group?broker_id=${broker_id}&customer_group_id=${customer_group_id}`)
              .then(() => {
                this.$snotify.success('Grupo de clientes excluído com sucesso!', this.$appStorage.getUser().name);
                this.filter(`/v1${this.$router.currentRoute.fullPath}`)
              })
              .catch(() => {
                this.$snotify.error('Erro ao excluir grupo de clientes!');
              });
          }
        }, {
          type: 'close',
          label: 'Não',
          method: this.destroyModal
        }
        ]
      });
    },
    destroyProduct(e, broker_id, customer_group_id, product_id) {
      e.stopPropagation();
      e.preventDefault();

      this.addModal({
        title: 'Excluir Produto',
        size: 'small',
        body: 'Deseja realmente excluir este produto?',
        buttons: [{
          type: 'ok',
          class: 'btn btn-danger btn-sm',
          method: id => {
            this.destroyModal(id);

            this.$appHttp.delete(`/v1/broker_customers_wallets/destroy_product?broker_id=${broker_id}&customer_group_id=${customer_group_id}&product_id=${product_id}`)
                .then(() => {
                  this.$snotify.success('Produto retirado do grupo de clientes do o corretor!', this.$appStorage.getUser().name);
                  this.filter(`/v1${this.$router.currentRoute.fullPath}`)
                })
                .catch(() => {
                  this.$snotify.error('Erro ao excluir produto!', this.$appStorage.getUser().name);
                });
          }
        }, {
          type: 'close',
          label: 'Não',
          method: this.destroyModal
        }
        ]
      });
    }
  },
  computed: {
    ...mapGetters(['brokers'])
  },
  created() {
    this.loadBrokers();
  }
}
</script>
<style scoped lang="scss">
@import "../../assets/css/variables";

  .products-container {
    overflow-x: auto;
    flex-direction: row;
    display: flex;
    flex-wrap: nowrap;
    justify-content: start;
    align-items: center;
    gap: 5px;
    scrollbar-width: thin;
    scroll-snap-type: x mandatory;

    > span {
      display: inline-block;
      text-overflow: unset;
      white-space: nowrap;
      background-color: $theme_color_eight;
      color: #fff;
      height: 17px;
      border-radius: 5px;
      padding-right: 5px;
      text-decoration: none;
      transition: background-color .3s ease;
      scroll-snap-align: start;
      user-select: none;

      > span {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        height: 17px;
        width: 17px;
        font-size: 1.2em;
        border-right: 1px solid rgba(255, 255, 255, .2);
        border-bottom-left-radius: 5px;
        border-top-left-radius: 5px;
        transition: all .3s ease;

        &:hover {
          background-color: $badge_red;
        }
      }
    }
  }
</style>